var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.25C12.5523 21.25 13 20.8023 13 20.25L13 10.8284L15.8787 13.7071C16.2692 14.0976 16.9024 14.0976 17.2929 13.7071C17.6834 13.3166 17.6834 12.6834 17.2929 12.2929L12.8287 7.82865C12.796 7.78231 12.759 7.73813 12.7175 7.69668C12.5196 7.49875 12.2593 7.40114 11.9999 7.40384C11.7406 7.40119 11.4804 7.4988 11.2825 7.69668C11.241 7.73813 11.204 7.78231 11.1713 7.82864L6.70711 12.2929C6.31658 12.6834 6.31658 13.3166 6.70711 13.7071C7.09763 14.0976 7.7308 14.0976 8.12132 13.7071L11 10.8284L11 20.25C11 20.8023 11.4477 21.25 12 21.25ZM3 5C3 5.55229 3.44772 6 4 6H20C20.5523 6 21 5.55229 21 5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadX2);
export default __webpack_public_path__ + "static/media/UploadX2.8061690f294965542c1731609db560bd.svg";
export { ForwardRef as ReactComponent };